<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YvRvyA/tc-custom/9780823228379.jpg?1721404630475" alt="This image is the cover for the book Dis-Enclosure, Perspectives in Continental Philosophy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dis-Enclosure, Perspectives in Continental Philosophy
      </h1>
      <p class="bookDescription body article font2">
        <b>From one of France’s leading contemporary thinkers, “an astutely reasoned philosophical text, offering a revolutionary analysis of theistic religion” (<i>The Midwest Book Review</i>).</b><br/><br/>This book is a profound and eagerly anticipated investigation into what is left of a monotheistic religious spirit—notably, a minimalist faith that is neither confessional nor credulous. Articulating this faith as works and as an objectless hope, Nancy deconstructs Christianity in search of the historical and reflective conditions that provided its initial energy. Working through Blanchot and Nietzsche, re-reading Heidegger and Derrida, Nancy turns to the Epistle of Saint James rather than those of Saint Paul, discerning in it the primitive essence of Christianity as hope.<br/><br/>The “religion that provided the exit from religion,” as he terms Christianity, consists in the announcement of an end. It is the announcement that counts, however, rather than any finality. In this announcement there is a proximity to others and to what was once called parousia. But parousia is no longer presence; it is no longer the return of the Messiah. Rather, it is what is near us and does not cease to open and to close, a presence deferred yet imminent.<br/><br/>In a demystified age where we are left with a vision of a self-enclosed world—in which humans are no longer mortals facing an immortal being, but entities whose lives are accompanied by the time of their own decline—parousia stands as a question. Can we venture the risk of a decentered perspective, such that the meaning of the world can be found both inside and outside, within and without our so-immanent world?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jean-Luc Nancy, Bettina Bergo, Gabriel Malenfant, Michael B. Smith
      </h2>
      
      <p class="authorDescription body article"><B>Jean-Luc Nancy</B> is Distinguished Professor of Philosophy at the Université Marc Bloch, Strasbourg. His wide-ranging thought is developed in many books, including <I>Portrait</I>, <I>The Possibility of a World</I>, <I>The Banality of Heidegger</I>, <I>The Disavowed Community,</I> and<I> Corpus.</I><br/><br/>Bettina Bergo is Assistant Professor of Philosophy at the University of Montréal and the author of Levinas: Between Ethics and Politics. The most recent of her many translations is, with Michael B. Smith, Judeities: Questions for Jacques Derrida (Fordham).<br/><br/>GABRIEL MALENFANT is a graduate student at the University of Montréal.<br/><br/>Michael B. Smith is Professor Emeritus of French and Philosophy at Berry College.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fordham University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0b87d83e